export default {
  welcome: '歡迎登入',
  subtitle: '請輸入您的帳號和密碼',
  email: '帳號',
  emailPlaceholder: '請輸入帳號',
  password: '密碼',
  passwordPlaceholder: '請輸入密碼',
  or: '或',
  noAccount: '還沒有帳號？',
  contactAdmin: '聯繫管理員',
  forgotPasswordTip: '請聯繫管理員重置密碼',
  contactAdminTip: '請聯繫管理員獲取帳號',
};
